import * as yup from 'yup';
import { RXLABEL_VALIDATION } from '../constants/rxLabel';
import { dateOfBirthValidation } from '@/lib/dataSchemas/dateOfBirthValidation';
import { DOB_ERROR_MSG } from '@/lib/constants/dateOfBirth';

export const rxLabelSchema = (allowYearOnly: boolean = false, validationMessages = { ...RXLABEL_VALIDATION, ...DOB_ERROR_MSG }) => {
  return yup
    .object({
      ...dateOfBirthValidation(allowYearOnly, validationMessages),
      storeNumber: yup
        .string()
        .required(validationMessages.STORE_NUMBER_REQUIRED)
        .min(3, validationMessages.STORE_NUMBER_INVALID)
        .max(5, validationMessages.STORE_NUMBER_INVALID)
        .matches(/^[0-9]*$/, {
          message: validationMessages.STORE_NUMBER_INVALID,
          excludeEmptyString: true
        }),
      prescriptionNumber: yup
        .string()
        .required(validationMessages.PRESCRIPTION_NUMBER_REQUIRED)
        .min(6, validationMessages.PRESCRIPTION_NUMBER_INVALID)
        .max(7, validationMessages.PRESCRIPTION_NUMBER_INVALID)
        .matches(/^[0-9]*$/, {
          message: validationMessages.PRESCRIPTION_NUMBER_INVALID,
          excludeEmptyString: true
        })
    })
    .required();
};
